import React from 'react';

// Simplified AdUnit that renders nothing as AdSense is currently disabled
interface AdUnitProps {
    slotId: string;
    format?: 'auto' | 'fluid' | 'rectangle';
    layoutKey?: string;
    style?: React.CSSProperties;
    className?: string;
    label?: string;
}

const AdUnit: React.FC<AdUnitProps> = () => {
    return null; // AdSense disabled
};

export default AdUnit;
